import React from 'react';
import classNames from 'classnames';
import { Button, ButtonPriority as PRIORITY, HoverStyles, Spinner } from '../../../ui';
import { SPINNER } from '../../../common/constants/data-hooks';
import TextExtended from '../text-extended/text-extended';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import styles from './load-more.module.scss';
export const LoadMore = ({ text, onClick, className, isPending = false, dataHook, icon }) => {
    const { screenshotMode } = useConfiguration();
    return (React.createElement(Button, { className: classNames(styles.root, className), onClick: onClick && onClick, priority: PRIORITY.secondary, "data-hook": dataHook, upgrade: true, hoverStyle: HoverStyles.underline },
        React.createElement(TextExtended, { typography: "buttonSecondary", priority: "buttonSecondary" }, text),
        icon ? icon : null,
        isPending ? (React.createElement(Spinner, { className: styles.spinnerRoot, "data-hook": SPINNER, diameter: 17, isStatic: screenshotMode })) : (React.createElement("div", { className: styles.spinnerPlaceholder }))));
};
//# sourceMappingURL=load-more.js.map